import Component from '../core/component';
import Enhance from '../core/enhance'
import tools from '../libs/tools';
import classnames from 'classnames';
import Router from './router'
import React from 'react'

const isModifiedEvent = (event) =>
    !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey)

/**
 * The public API for rendering a history-aware <a>.
 */
class RouteLink extends Component {


    handleClick = (event) => {
        // console.log('handleClick');
        if (this.props.onClick)
            this.props.onClick(event)

        if (
            !event.defaultPrevented && // onClick prevented default
            event.button === 0 && // ignore everything but left clicks
            !this.props.target && // let browser handle "target=_blank" etc.
            !isModifiedEvent(event) // ignore clicks with modifier keys
        ) {
            event.preventDefault()
            const {replace, push, pop} = this.props;
            if (pop != null && tools.is_int(pop)) {
                Router.pop(-Math.abs(pop))
            } else if (push != null) {
                if (replace) {
                    Router.replace(push, {});
                } else {
                    Router.push(push, {});
                }

            }
        }
    }

    render() {
        return (
            <a
                className={classnames('c-route-link', this.props.className)}
                style={this.props.style}
                onClick={this.handleClick}
                href="javascript:void(0)"
            >
                {this.props.children}
            </a>
        )
    }
}

Enhance(RouteLink, {}, 'RouteLink');
export default RouteLink
